import { useCallback, useEffect, useRef } from 'react';

export const useLatest = <T extends (...args: any) => any>(instance: T) => {
  const ref = useRef(instance);

  useEffect(() => {
    ref.current = instance;
  }, [ref, instance]);
  const refFree = useCallback((...args: any) => ref.current(...args), [ref]);

  return refFree as unknown as T;
};

export const useLatestRef = <T>(args: T) => {
  const ref = useRef(args);

  useEffect(() => {
    ref.current = args;
  }, [args]);

  return ref;
};
